import React from "react";
import "./HierarchySelect.css";
import { useTranslation } from "react-i18next";
import "react-dropdown-tree-select/dist/styles.css";
import { Controller } from "react-hook-form";
import HierarchyDropdownForRole from "../../../../../Components/UiComponents/HierarchyDropdown/HireForRole";

const treeSelectStyles = `
  .react-dropdown-tree-select .node {
    display: flex !important;
    align-items: center !important;
    flex-direction: row !important;
    flex-wrap: nowrap !important;
    padding: 4px 2px;
  }

  .react-dropdown-tree-select .toggle {
    display: inline-flex !important;
    align-items: center;
    justify-content: center;
    min-width: 20px;
    width: 20px;
    margin-right: 6px !important;
    font-size: 14px;
    flex-shrink: 0;
    cursor: pointer;
    color: #333;
  }

  .react-dropdown-tree-select .node.leaf > label,
  .react-dropdown-tree-select .node.leaf > input[type="checkbox"] {
    margin-left: 26px;
  }

  .react-dropdown-tree-select .node input[type="checkbox"] {
    display: inline-block !important;
    width: 15px !important;
    height: 15px !important;
    margin: 0 8px 0 0 !important;
    flex-shrink: 0;
    vertical-align: middle;
    cursor: pointer;
  }

  .react-dropdown-tree-select .node label {
    display: inline-flex !important;
    align-items: center;
    margin: 0 !important;
    cursor: pointer;
    font-size: 14px;
    color: #333;
    flex: 1;
  }

  .react-dropdown-tree-select .node-child {
    padding-left: 24px;
  }

  .react-dropdown-tree-select ul {
    padding-left: 12px;
    margin: 0;
    list-style: none;
  }

  .react-dropdown-tree-select ul.root {
    padding-left: 4px;
    list-style: none;
  }

  .react-dropdown-tree-select ul li {
    list-style: none;
    padding: 1px 0;
  }

  .react-dropdown-tree-select .dropdown-content {
    padding: 6px 4px;
    min-width: 250px;
  }

  .react-dropdown-tree-select .dropdown-trigger {
    width: 100%;
    border: 1px solid #ced4da;
    border-radius: 4px;
    padding: 4px 8px;
    min-height: 36px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    cursor: pointer;
    background: white;
  }

  .react-dropdown-tree-select .dropdown-trigger input {
    border: none;
    outline: none;
    flex: 1;
    min-width: 60px;
    font-size: 14px;
  }

  .has-error .react-dropdown-tree-select .dropdown-trigger {
    border: 1px solid #dc3545 !important;
  }
`;

const HierarchySelectForRole = ({
  name,
  label,
  register,
  errors,
  options,
  control,
  mandatory,
  onChange,
  disabled = false,
  mobileAccess,
  getValues,
  treeKey,
}) => {
  const { t } = useTranslation();

  return (
    <div>
      {/* Inject styles for react-dropdown-tree-select layout */}
      <style>{treeSelectStyles}</style>

      <label style={{ color: disabled ? "#6c759d" : "" }}>
        {t(label)}
        {mandatory && <span className="asterisk">*</span>}
      </label>
      <Controller
        control={control}
        name={name}
        render={({ field: { value, onChange: fieldOnChange } }) => (
          <HierarchyDropdownForRole
            key={`hierarchy-dropdown-${treeKey}`}
            data={options || null}
            className={errors[name] ? "has-error" : ""}
            value={value}
            onChange={(currentNode, selectedNodes) => {
              fieldOnChange(selectedNodes);
              if (onChange) {
                onChange(currentNode, selectedNodes);
              }
            }}
            id={name}
            disabled={disabled}
            mobileAccess={mobileAccess}
          />
        )}
      />
      <div className="error__message">{errors[name]?.message}</div>
    </div>
  );
};

export default HierarchySelectForRole;